import { GetLocal } from "../utilities/AxiosUtility";
import { localPort, version } from "../utilities/Constants";
import Cookie, { removeSession } from "../utilities/CookieUtility";

export default class Balance {
  static async getBalance(event) {
    const response = await GetLocal(`${localPort}/${version}/ddish/getBalance`);
    if (response) {
      if (response.data.resultMessage == "token has been expired") {
        Cookie.remove("auth");
        window.location.reload();
      } else {
        return response.data.balance;
      }
    } else {
      return "0";
    }
  }
}
